"use client"

import { useRef } from "react"
import { motion, useScroll, useTransform } from "framer-motion"
import { ThreeDMarquee } from "./components/three-d-marquee"

export function NftsSection() {
    const containerRef = useRef<HTMLElement>(null)
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start end", "end start"],
    })

    const y = useTransform(scrollYProgress, [0, 1], ["-20%", "20%"])

    return (
        <section
            ref={containerRef}
            className="relative h-screen w-full overflow-hidden"
        >
            <div className="absolute inset-0 z-10 flex h-full w-full items-center justify-center backdrop-blur-xs">
                <h2 className="text-background text-center text-4xl lg:text-6xl">
                    <span className="bg-primary px-2 backdrop-blur-sm">
                        NSFW NFT Collection
                    </span>
                    <br />
                    <span className="bg-primary px-2 backdrop-blur-sm">
                        Coming Soon
                    </span>
                </h2>
            </div>
            <motion.div className="absolute inset-0" style={{ y }}>
                <ThreeDMarquee
                    images={DemoNftsImages}
                    cols={8}
                    className="bg-background"
                />
            </motion.div>
        </section>
    )
}

const DemoNFTsData: Array<{
    id: number
    imageSrc: string
    priceSOL: number
    likesNum: number
    viewsNum: number
}> = [
    {
        id: 6745,
        imageSrc: "/nfts/farthub-4.jpg",
        priceSOL: 1.34,
        likesNum: 289,
        viewsNum: 1100,
    },
    {
        id: 9823,
        imageSrc: "/nfts/farthub-6.jpg",
        priceSOL: 1.95,
        likesNum: 499,
        viewsNum: 2999,
    },
    {
        id: 1098,
        imageSrc: "/nfts/farthub-5.jpg",
        priceSOL: 0.65,
        likesNum: 411,
        viewsNum: 2567,
    },
    {
        id: 3321,
        imageSrc: "/nfts/farthub-8.jpg",
        priceSOL: 0.55,
        likesNum: 110,
        viewsNum: 1050,
    },
    {
        id: 5543,
        imageSrc: "/nfts/farthub-7.jpg",
        priceSOL: 1.62,
        likesNum: 376,
        viewsNum: 2431,
    },
    {
        id: 4582,
        imageSrc: "/nfts/farthub-1.jpg",
        priceSOL: 1.78,
        likesNum: 345,
        viewsNum: 2189,
    },
    {
        id: 2398,
        imageSrc: "/nfts/farthub-3.jpg",
        priceSOL: 1.99,
        likesNum: 487,
        viewsNum: 2890,
    },
    {
        id: 8734,
        imageSrc: "/nfts/farthub-2.jpg",
        priceSOL: 0.89,
        likesNum: 123,
        viewsNum: 1543,
    },
    {
        id: 6744,
        imageSrc: "/nfts/farthub-4.jpg",
        priceSOL: 1.34,
        likesNum: 289,
        viewsNum: 1100,
    },
    {
        id: 9822,
        imageSrc: "/nfts/farthub-6.jpg",
        priceSOL: 1.95,
        likesNum: 499,
        viewsNum: 2999,
    },
    {
        id: 3251,
        imageSrc: "/nfts/farthub-9.jpg",
        priceSOL: 1.95,
        likesNum: 499,
        viewsNum: 2999,
    },
    {
        id: 3252,
        imageSrc: "/nfts/farthub-10.jpg",
        priceSOL: 1.95,
        likesNum: 499,
        viewsNum: 2999,
    },
]

const DemoNftsImages = DemoNFTsData.map((nft) => ({
    src: nft.imageSrc,
    alt: "NSFW NFT",
}))
